// extracted by mini-css-extract-plugin
export default {"cell":"InvoicePromiseToPayCell_cell__5nPxi","dateInput":"InvoicePromiseToPayCell_dateInput__a2y4g","error":"InvoicePromiseToPayCell_error__gziE-"};